<template>
    <div class="row">
        <div class="col-sm-12">
            <header-list
                :title="pageTitle"
                :placeholderSearch="searchPlaceholder"
                v-model="query"
                :routeAddName="finalRouteAddName"
                :canAdd="canAdd"
                :addTitle="addTitle"
                :canConfig="canConfig"
                :routeConfigName="finalRouteConfigName"
                :configTitle="headerConfigTitle"
                @search="onSearch">
            </header-list>

            <div class="row">
                <div class="col">
                    <div id="accordion">
                        <div class="card accordion"
                            v-for="(item, idx) in lists.header"
                            :key="`item-${idx}`">
                            <div class="card-header">
                                <div class="row no-gutters">
                                    <div class="col" :id="'heading'+item.id" data-toggle="collapse" :data-target="'#collapse'+item.id" :aria-expanded="expandId == item.id" :aria-controls="'collapse'+item.id">
                                        {{item.name}}
                                    </div>
                                </div>
                            </div>
                            <div :id="'collapse'+item.id" class="collapse" :class="{'show': expandId == item.id}" :aria-labelledby="'heading'+item.id" data-parent="#accordion">
                                <div class="card-body">
                                    <table-data
                                        :showTitleData="false"
                                        :data="item.automatic ? automatic : manuals"
                                        :settings="table.settings"
                                        :columns="tableColumns"
                                        :inlineFilters="table.filters"
                                        :autoUpdateFilter="table.autoUpdateFilter"
                                        :addParamsToUrl="table.addParamsToUrl"
                                        :loadingMsg="table.loadingMsg"
                                        :notFoundMsg="table.notFoundMsg"
                                        :orderByTemplate="table.orderByTemplate"
                                        :showPagination="table.showPagination"
                                        :tableInline="table.tableInline"
                                        tableClass="table-responsive-sm"
                                        @error-load="showError"
                                    >
                                        <template v-slot:body="{columns, row, index, remove}">
                                            <td v-for="(column, idx) in columns"
                                                :key="`row-${row.id}-column-${idx}`"
                                                v-if="column.field || column.field_label"
                                                :class="[column.class, {'tbl-column-disabled': !!!row.status}]">
                                                <template v-if="column.field == 'targets'">
                                                    <ul class="list-circle m-0 pl-3">
                                                        <li v-for="child in row[column.field]"
                                                            :key="`target-${child.id}`">
                                                            {{ columnValue(child, column) }}
                                                        </li>
                                                    </ul>
                                                </template>
                                                <template v-else>
                                                    {{ columnValue(row, column) }}
                                                </template>
                                            </td>
                                            <column-actions
                                                v-if="checkActions"
                                                :routeEdit="`${moduleCode}.${pageID}.show`"
                                                @delete="deleteItem"
                                                label="subject"
                                                :canDetail="canDetail"
                                                :canEdit="canEdit"
                                                :canDelete="canDelete"
                                                :row="row"
                                                :index="index"
                                                :callbackDelete="remove" />
                                        </template>
                                    </table-data>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GeneralMixin from './mixins/GeneralMixin'

    export default {
        mixins: [
            GeneralMixin,
        ],
        props: {
            componentId: {
                type: String,
                require: true,
            },
            columns: {
                type: Array,
                default: () => {return [];},
            },
            headerRouteAddName: {
                type: String,
                default: null,
            },
            headerRouteConfigName: {
                type: String,
                default: null,
            },
            headerConfigTitle: {
                type: String,
                default: 'global.config',
            },
        },
        data() {
            return {
                pageID: null,
                pageTitle: 'List',
                table: {
                    showPagination: false,
                    tableInline: true,
                },
                lists: {
                    loaded: true,
                    header: [
                        {
                            id: 1,
                            name: 'Manuais',
                            automatic: false
                        }, {
                            id: 2,
                            name: 'Automáticas',
                            automatic: true
                        }
                    ],
                },

            }
        },
        beforeMount() {
            this.pageID = this.componentId;
        },
        computed: {
            finalRouteConfigName() {
                return this.headerRouteConfigName || `${this.moduleCode}.${this.pageID}.config`;
            },
            finalRouteAddName() {
                return this.headerRouteAddName || `${this.moduleCode}.${this.pageID}.create`;
            },
            defaultTableColumns() {
                return [
                    {
                        label: `${this.pageID}.model.name`,
                        field: 'name',
                        sortable: true,
                    },
                    // {
                    //     label: `${this.pageID}.model.subject`,
                    //     field: 'subject',
                    //     sortable: false,
                    // },
                    {
                        label: `${this.pageID}.model.targets_abbr`,
                        field: 'targets',
                        field_label: 'name',
                        sortable: false,
                        // class: 'd-none d-sm-table-cell',
                    },
                    {
                        label: `${this.pageID}.model.channel_id_abbr`,
                        field: 'channel_id',
                        field_label:  'channel.name',
                        sortable: false,
                        // class: 'd-none d-sm-table-cell',
                    },
                    {
                        label: '',
                        field: null,
                        sortable: false,
                        class: 'actions',
                    }
                ]
            },
            tableColumns() {
                return this.columns && this.columns.length>0 ? this.columns : this.defaultTableColumns;
            },
            automatic() {
                return this.list.filter(item => item.automatic);
            },
            manuals() {
                return this.list.filter(item => !item.automatic);
            },
            expandId() {
                if(this.automatic.length==0 && this.manuals.length==0){
                    return null;
                }
                return this.lists.header[0].automatic ? (this.automatic.length>0 ? this.lists.header.find(item=>item.automatic).id : null) : (this.manuals.length>0 ? this.lists.header.find(item=>item.automatic==false).id : this.lists.header.find(item=>item.automatic).id);
            },
        },
    }
</script>
